import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PopoverOptions } from '@shared/types';

import { PopoverState } from './types';

const initialState: PopoverState = {
  popover: {
    anchorElId: null,
    content: null,
    isOpen: false,
  },
};

export const popoverSlice = createSlice({
  name: 'popover',
  initialState,
  reducers: {
    openPopover: (state: PopoverState, { payload }: PayloadAction<PopoverOptions>) => {
      state.popover = payload;
    },
    closePopover: (state: PopoverState) => {
      state.popover = { anchorElId: null, content: null, isOpen: false };
    },
  },
});

export const { openPopover, closePopover } = popoverSlice.actions;

export const popoverSliceReducer = popoverSlice.reducer;
